








































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Accordion, Button } from '@/pages/profile/components';
import { Avatar, Info, Warning } from './components';
import { IChild, ToolTextEnum, ModulesEnum } from './types';

@Component({
  components: {
    Warning,
    Avatar,
    Info,
    Accordion,
    Button,
  },
})
export default class Child extends Vue implements IChild {
  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: String, default: '' })
  readonly photo!: string;

  @Prop({ type: String, default: 'M' })
  readonly gender!: string;

  @Prop({ type: String, default: '' })
  readonly name!: string;

  @Prop({ type: String, default: '' })
  readonly surname!: string;

  @Prop({ type: String, default: '' })
  readonly age!: string;

  @Prop({ type: Boolean, default: false })
  readonly active!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly modal!: boolean;

  @Prop({ type: Number, default: 0 })
  readonly index!: number;

  @Prop({ type: Array, default: () => [] })
  readonly modules!: Array<string>;

  @Prop({ type: Boolean, default: false })
  readonly isProgress: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isPfdod: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isApproved: boolean;

  @Watch('watchCheckVisibility')
  visibilityWatcher(val: number) {
    this.$refs.accordion.onToggle();
  }

  get toolTipText(): string {
    return this.isApproved ? ToolTextEnum.CONFIRMED : ToolTextEnum.NO_CONFIRMED;
  }

  get pfdodModule(): boolean {
    return this.modules.includes(ModulesEnum.PFDOD);
  }

  get isIndicator(): boolean {
    return this.pfdodModule;
  }

  get hasApiModuleConsultations() {
    return this.$store.getters.hasApiModuleConsultations;
  }

  get hasApiModulePortfolio() {
    return this.$store.getters.hasApiModulePortfolio;
  }

  get isSetting() {
    return this.$route.matched.some(
      (record) => record.meta.isInnerSettingsRoutes
    );
  }

  get isFavorite() {
    return this.$route.matched.some((record) => record.meta.isInnerRoutes);
  }

  get visibility(): any {
    return {
      'result-courses': { favorite: false, settings: false },
      consultations: { favorite: false, settings: false },
      progress: { favorite: false, settings: false },
    };
  }

  get watchCheckVisibility() {
    return [
      this.isVisibleElemResultCourses,
      this.isVisibleElemProgress,
      this.isVisibleElemConsultations,
    ];
  }

  get isVisibleElemResultCourses() {
    return this.checkVisibilityByName('result-courses');
  }

  get isVisibleElemProgress() {
    return this.checkVisibilityByName('progress');
  }

  get isVisibleElemConsultations() {
    return this.checkVisibilityByName('consultations');
  }

  checkVisibilityByName(name: string): boolean {
    if (this.visibility[name]) {
      if (this.visibility[name].favorite === false && this.isFavorite) {
        return false;
      }
      if (this.visibility[name].settings === false && this.isSetting) {
        return false;
      }
    }
    return true;
  }

  get isDisabled(): boolean {
    const { pfdodModule, isApproved, index } = this;
    return index !== 0
      ? pfdodModule && isApproved
      : this.$route.matched.some((record) => record.meta.isInnerSettingsRoutes);
  }
  get routeMeta(): any {
    return this.$route.meta;
  }

  childEditDelete(eventName: string) {
    this.$emit(eventName, eventName);
  }

  childSelected(): void {
    if (!this.active) {
      this.$emit('selected', this.index);
    }
  }

  modalEvent(event: string) {
    this.$emit('modalEvent', event);
  }

  routeControl(name: string): void {
    this.$router.push({
      name: `profile-${name}`,
    });
  }
  pushToSettings() {
    window.location.assign('/profile/settings#access');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/Child.vue